import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import './styles.css'

// The hangar screen works offline: its service worker keeps the page and the last readings (public/sw.js).
if ('serviceWorker' in navigator && window.location.pathname.startsWith('/kiosk/') && !window.location.pathname.startsWith('/kiosk/demo')) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined))
}

const root = document.getElementById('root')
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
